/**
 * @file Next.jsカスタムAppコンポーネント
 *
 * 全ページ共通のルートコンポーネント。
 * - グローバルCSSのインポート
 * - RecoilRootによる状態管理の提供
 * - Layoutコンポーネントで共通ヘッダー・フッターを適用
 * - 開発環境ではMSW（Mock Service Worker）を起動してから描画
 */
import '@/styles/common_defult.css';
import '@/styles/common_customize.css';
import '@/styles/common.css';
import '@/styles/utility.css';
import '@/styles/style.css';

import type { AppProps } from 'next/app';
import { RecoilRoot } from 'recoil';
import { useEffect, useState } from 'react';
import Layout from '../components/Layout';

/** 開発環境かどうかの判定（MSW起動制御用） */
const API_MOCKING = process.env.NODE_ENV === 'development';

const MyApp = ({ Component, pageProps }: AppProps) => {
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    if (API_MOCKING) {
      (async () => {
        const { mockServerReady } = await import('../mocks/worker');
        await mockServerReady;
        setShouldRender(true);
      })();
    } else {
      setShouldRender(true);
    }
  }, []);

  if (!shouldRender) {
    return null;
  }

  return (
    <RecoilRoot>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </RecoilRoot>
  );
};

export default MyApp;
